import { Grid } from "@material-ui/core";
import { React, useState } from "react";
import Loader from "../../../Utilities/Loader/Loader";
import StatusItem from "./StatusItem/StatusItem";

export default function StatusList({
  selectedTrackable,
  projectStatus,
  trackableClass,
  handleDeleteStatusModal,
  handleEditStatusModal,
}) {
  return (
    <Grid
      container
      spacing={2}
      style={{
        // display: "flex",
        // gap: "0.4%",
        // flexWrap: "wrap",
        marginTop: "1%",
      }}
    >
      {projectStatus.length > 0 ? (
        projectStatus.map((el) => (
          <Grid item xl={2} lg={3} md={4}>
            <StatusItem
              status={el}
              selectedTrackable={selectedTrackable}
              trackableClass={trackableClass}
              handleDeleteStatusModal={handleDeleteStatusModal}
              handleEditStatusModal={handleEditStatusModal}
            />
          </Grid>
        ))
      ) : (
        <Loader />
      )}
    </Grid>
  );
}
